import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getFocusGroupStimuliForProject = async (projectId) => {
    const { data } = await vlqrApi.get(`projects/${projectId}/focusGroupStimuli`)
        .catch((error) => {
            handleError(error);
        });

    return data;
};

const useFocusGroupStimuliForProject = (projectId) => {
    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: ['focusGroupStimuliForProject', projectId],
        queryFn: () => getFocusGroupStimuliForProject(projectId)
    });

    return { data, refetch, isLoading, isError };
};

export default useFocusGroupStimuliForProject;
